import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { CartComponent } from "./cart.component";

const routes: Routes = [
  {
    path: '',
    data: {
      title: 'Cart'
    },
    children: [
      {
        path: '',
        component: CartComponent,
        data: {
          title: 'Home'
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CartRoutingModule { }
